// Api
import AxiosClient from '@api/axiosClient';
// Models
import {
    IApproveDocumentsParams,
    IApiResponse,
    BasicCompanyOnboardingInformation,
    IDueDiligenceStatusParams,
    IPendingDocuments,
    ISaveStepData,
    IDueDiligenceStatusResposne,
} from '@models/Onboarding';
// Urls
import { urls } from './urls';

export const apiGetPendingDocuments = (
    companyData: BasicCompanyOnboardingInformation
): Promise<IApiResponse<IPendingDocuments[]>> => AxiosClient.post(urls.onboarding.pendingDocuments, companyData);

export const apiPostPendingDocuments = (approveInformation: IApproveDocumentsParams): Promise<IApiResponse<string>> =>
    AxiosClient.post(urls.onboarding.approvePendingDocuments, approveInformation);

export const apiPostSaveStep = <T>(data: ISaveStepData): Promise<T> => AxiosClient.post(urls.onboarding.saveStep, data);

export const apiPostGetDueDiligenceStatus = (
    data: IDueDiligenceStatusParams
): Promise<IApiResponse<IDueDiligenceStatusResposne>> => AxiosClient.post(urls.onboarding.dueDiligenceStatus, data);
